import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_8 = { class: "float-end" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12" };
const _hoisted_10 = {
    key: 0,
    class: "card bg-white data-grid company-detail-grid detached"
};
const _hoisted_11 = {
    key: 1,
    class: "card bg-white data-grid data-grid-auto detached bottom10"
};
const _hoisted_12 = { class: "table table-hover bottom0 pw100" };
const _hoisted_13 = { class: "text-center hidden-sm" };
const _hoisted_14 = { class: "hidden-sm" };
const _hoisted_15 = ["title"];
const _hoisted_16 = {
    key: 1,
    class: "badge bg-success"
};
const _hoisted_17 = {
    key: 2,
    class: "badge bg-secondary"
};
const _hoisted_18 = { class: "hidden-sm" };
const _hoisted_19 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = { class: "x_panel" };
const _hoisted_22 = { class: "x_content" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_24 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_25 = { class: "batch-files-scroll" };
const _hoisted_26 = { class: "table table-sm" };
const _hoisted_27 = { class: "text-center" };
const _hoisted_28 = { class: "float-end float-start-sm" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { key: 0 };
const _hoisted_31 = { key: 0 };
const _hoisted_32 = { class: "text-success" };
const _hoisted_33 = { key: 1 };
const _hoisted_34 = { class: "text-danger" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                ]))])
                        ])
                    ])
                ]),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.addBatch()))
                        }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                    _createElementVNode("span", { class: "hidden-xs" }, " Add Files", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]),
            _cache[23] || (_cache[23] = _createTextVNode()),
            _createCommentVNode(" Flat file listing "),
            _cache[24] || (_cache[24] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
                (_ctx.noData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("div", {
                                class: "text-center pw100",
                                style: { "padding": "20px" }
                            }, [
                                _createElementVNode("h5", null, "There are no records matching your criteria.")
                            ], -1 /* CACHED */)
                        ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("table", _hoisted_12, [
                            _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, "Date/Time"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "hidden-sm" }, "File Name"),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, "Status"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "hidden-sm" }, "Who Created")
                                ])
                            ], -1 /* CACHED */)),
                            _cache[21] || (_cache[21] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: item.id,
                                        class: _normalizeClass({ 'deleted': item.whenDeleted })
                                    }, [
                                        _createElementVNode("td", _hoisted_13, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.downloadFile(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                        _createElementVNode("span", { class: "fa fa-download" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Download File\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[15] || (_cache[15] = _createTextVNode()),
                                                            (_ctx.isFailed(item))
                                                                ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                    key: 0,
                                                                    onClick: ($event) => (_ctx.retry(item))
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                            _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                            _createTextVNode(" Retry Upload\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                        ]))]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["onClick"]))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.getDateTimeFormatted(item.whenCreated)), 1 /* TEXT */),
                                        _cache[17] || (_cache[17] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.fileName), 1 /* TEXT */),
                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                        _createElementVNode("td", null, [
                                            (_ctx.isFailed(item))
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    class: "badge bg-danger",
                                                    title: item.apiReponse
                                                }, "Failed", 8 /* PROPS */, _hoisted_15))
                                                : (_ctx.isSucceeded(item))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Succeeded"))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "(Unknown)"))
                                        ]),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_18, _toDisplayString(item.userName), 1 /* TEXT */)
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ])
                    ])),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end",
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _cache[51] || (_cache[51] = _createTextVNode()),
        _createCommentVNode(" Batch upload modal "),
        _cache[52] || (_cache[52] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            id: "data-collector-register-modal",
            modelValue: _ctx.showRegisterModal,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.showRegisterModal) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("span", null, "Add identification files", -1 /* CACHED */)
                ]))]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.saveBatch,
                        disabled: _ctx.saveButtonDisabled || !_ctx.batchFiles.length
                    }, {
                        default: _withCtx(() => [
                            _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */)),
                            _createTextVNode(" Upload " + _toDisplayString(_ctx.batchFiles.length) + " file", 1 /* TEXT */),
                            (_ctx.batchFiles.length !== 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "s"))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                    _cache[39] || (_cache[39] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createTextVNode(" Cancel\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _cache[40] || (_cache[40] = _createTextVNode()),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Files (*.key or *.zip) *", -1 /* CACHED */)),
                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                        _createElementVNode("input", {
                                            ref: "fileInput",
                                            class: "form-control",
                                            type: "file",
                                            name: "fileInput",
                                            accept: ".key,.zip",
                                            multiple: "",
                                            onChange: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => (_ctx.filesChanged && _ctx.filesChanged(...args)))
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                                        _cache[28] || (_cache[28] = _createTextVNode()),
                                        _cache[29] || (_cache[29] = _createElementVNode("small", { class: "text-muted" }, "A .zip archive will be expanded on the server and each .key entry uploaded individually.", -1 /* CACHED */))
                                    ]),
                                    _cache[36] || (_cache[36] = _createTextVNode()),
                                    (_ctx.batchFiles.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _cache[34] || (_cache[34] = _createElementVNode("label", null, "Selected files", -1 /* CACHED */)),
                                            _cache[35] || (_cache[35] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_25, [
                                                _createElementVNode("table", _hoisted_26, [
                                                    _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "File"),
                                                            _createTextVNode(),
                                                            _createElementVNode("th", { style: { "width": "80px" } })
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[33] || (_cache[33] = _createTextVNode()),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchFiles, (row, ix) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: row.fileName + ix
                                                            }, [
                                                                _createElementVNode("td", null, _toDisplayString(row.fileName), 1 /* TEXT */),
                                                                _cache[31] || (_cache[31] = _createTextVNode()),
                                                                _createElementVNode("td", _hoisted_27, [
                                                                    _createVNode(_component_b_button, {
                                                                        size: "sm",
                                                                        variant: "outline-danger",
                                                                        onClick: ($event) => (_ctx.removeBatchFile(ix))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"])
                                                                ])
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[41] || (_cache[41] = _createTextVNode())
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _cache[53] || (_cache[53] = _createTextVNode()),
        _createCommentVNode(" Batch result modal "),
        _cache[54] || (_cache[54] = _createTextVNode()),
        _createVNode(_component_b_modal, {
            modelValue: _ctx.showResultModal,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.showResultModal) = $event)),
            size: "lg",
            "header-bg-variant": "normal",
            "ok-only": "",
            "ok-title": "Close"
        }, {
            title: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("Upload results", -1 /* CACHED */)
                ]))]),
            default: _withCtx(() => [
                _cache[50] || (_cache[50] = _createTextVNode()),
                (_ctx.lastResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_ctx.lastResult.succeeded && _ctx.lastResult.succeeded.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("h5", _hoisted_32, [
                                    _cache[43] || (_cache[43] = _createElementVNode("i", { class: "fa fa-check" }, null, -1 /* CACHED */)),
                                    _createTextVNode(" Succeeded (" + _toDisplayString(_ctx.lastResult.succeeded.length) + ")", 1 /* TEXT */)
                                ]),
                                _cache[44] || (_cache[44] = _createTextVNode()),
                                _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastResult.succeeded, (item) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: 'ok-' + item.registerId
                                        }, _toDisplayString(item.fileName), 1 /* TEXT */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[49] || (_cache[49] = _createTextVNode()),
                        (_ctx.lastResult.failed && _ctx.lastResult.failed.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("h5", _hoisted_34, [
                                    _cache[45] || (_cache[45] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1 /* CACHED */)),
                                    _createTextVNode(" Failed (" + _toDisplayString(_ctx.lastResult.failed.length) + ")", 1 /* TEXT */)
                                ]),
                                _cache[46] || (_cache[46] = _createTextVNode()),
                                _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastResult.failed, (item) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: 'fail-' + item.registerId
                                        }, [
                                            _createElementVNode("strong", null, _toDisplayString(item.fileName), 1 /* TEXT */),
                                            _createTextVNode(" — " + _toDisplayString(item.errorMessage), 1 /* TEXT */)
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _cache[47] || (_cache[47] = _createTextVNode()),
                                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "alert alert-info" }, "\r\n\t\t\t\t\t\tYou can retry a failed upload from the file row (three-dot menu → Retry Upload).\r\n\t\t\t\t\t", -1 /* CACHED */))
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _cache[55] || (_cache[55] = _createTextVNode()),
        _createCommentVNode(" Hidden file input used for the Retry flow "),
        _cache[56] || (_cache[56] = _createTextVNode()),
        _createElementVNode("input", {
            ref: "retryFileInput",
            type: "file",
            accept: ".key",
            style: { "display": "none" },
            onChange: _cache[7] || (_cache[7] =
                //@ts-ignore
                (...args) => (_ctx.retryFileChanged && _ctx.retryFileChanged(...args)))
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
        _cache[57] || (_cache[57] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
